import script from "./table-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./table-editor.vue?vue&type=script&setup=true&lang=ts"

import "./table-editor.vue?vue&type=style&index=0&id=687b9323&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-687b9323"]])

export default __exports__